import React, { useMemo, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar
} from "../../../../_metronic/_partials/controls";
import { useOrganizationReportUIContext } from "./OrganizationReportUIContext";
import OrganizationReportTable from "./organization-report-table/OrganizationReportTable";
import { OrganizationReportFilter } from "./organization-report-table/organization-program-filter/OrganizationReportFilter";
import { RoleChecker } from "../../../RoleChecker";
import { Collapse } from "react-bootstrap";

export const OrganizationReportCard = () => {
  const [openFilter, setOpenFilter] = useState(false);
  const organizationReportUIContext = useOrganizationReportUIContext();
  const organizationReportUIProps = useMemo(() => {
    return {
      newOrganizationReportButtonClick:
        organizationReportUIContext.newOrganizationReportButtonClick
    };
  }, [organizationReportUIContext]);

  return (
    <Card>
      <CardHeader title="Laporan Konsolidasi Lembaga">
        <CardHeaderToolbar>
          <button
            type="button"
            className="btn btn-warning mx-1"
            onClick={() => setOpenFilter(!openFilter)}
          >
            Pencarian
          </button>
          {/* {RoleChecker("Create", "organizationReport") && ( */}
          <button
            type="button"
            className="btn btn-primary mx-1"
            onClick={organizationReportUIProps.newOrganizationReportButtonClick}
          >
            Tambah Laporan
          </button>
          {/* )} */}
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <Collapse in={openFilter}>
          <div id="collapse-filter-org-report">
            <OrganizationReportFilter />
          </div>
        </Collapse>
        <OrganizationReportTable />
      </CardBody>
    </Card>
  );
};
